import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationArrow from './NavigationArrow/NavigationArrow';
import NavigationTitle from './NavigationTitle/NavigationTitle';
import './Navigation.css';
import { setStartDayId, columnsUpdate } from '../../../../../redux/actions';
import { RESIZE_LIMITS } from '../../../../../constants';

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.navigation = this.navigation.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentWillMount() {
    // todo - maybe move resize stuff somewhere up
    window.addEventListener('resize', this.handleResize);
    // init resize
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // -------------------------------------------------------
  // Resize
  // -------------------------------------------------------

  handleResize() {
    const winW = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    let columns = 1;
    for (let i = 0; i < RESIZE_LIMITS.COLUMNS.length; i += 1) {
      if (winW > RESIZE_LIMITS.COLUMNS[i][0]) {
        columns = RESIZE_LIMITS.COLUMNS[i][1];
        break;
      }
    }
    // try update
    // todo - unify naming
    if (columns !== this.props.columns) {
      this.props.columnsUpdate(columns);
      // todo - dirty as hell
      setTimeout(() => {
        this.navigation(0);
      }, 100);
    }
  }

  // -------------------------------------------------------
  // Navigation
  // -------------------------------------------------------

  navigation(type) {
    const { startDayId, columns, endDayId } = this.props;
    // todo - revise - naming weirdness
    const maxStartDayId = Math.max(endDayId - (columns - 1), 0);
    const nextStartDayId = Math.min(
      Math.max(startDayId + columns * type, 0),
      maxStartDayId
    );
    this.props.setStartDayId(nextStartDayId);
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { startDayId, endDayId, columns } = this.props;
    return (
      <div id="head-navigation">
        <NavigationArrow
          onNav={this.navigation}
          type={-1}
          enabled={startDayId > 0}
        />
        <NavigationTitle startDayId={startDayId} columns={columns} />
        <NavigationArrow
          onNav={this.navigation}
          type={1}
          enabled={startDayId <= endDayId - columns}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  startDayId: state.navigation.startDayId,
  columns: state.navigation.columns,
  endDayId: state.navigation.endDayId
});

const mapDispatchToProps = dispatch => ({
  setStartDayId: startDayId => dispatch(setStartDayId(startDayId)),
  columnsUpdate: columns => dispatch(columnsUpdate(columns))
});

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/Navigation/Navigation.js